export default "__VITE_ASSET__27c3024b__"